import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {ref} from 'vue'
import SalaryTemplate from '@/views/ViewsComponents/orgBalance/BalanceTemplate.vue'
import Api from '@/http/modules/index'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 团队余额-根据团队获取信息
  'POST/order_profit/org_report': fetchList,
} = Api

const searchConfig = ref([
  {
    type: 'SELECT',
    label: '是否更新',
    value: false,
    upKey: 'update',
    options: [
      {label: '是', id: true},
      {label: '否', id: false},
    ],
    props: { clearable: false, filterable: false, placeholder: '请选择是否更新'},
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    type: "TIME",
    label: "日期",
    value: [dayjs().startOf('year').format('YYYY-MM-DD'), dayjs().endOf('year').format('YYYY-MM-DD')],
    upKey: 'dates',
    upProps: { startKey: 'startDate', endKey: 'endDate' },
    props: {
      type: 'monthrange',
      'value-format': 'YYYY-MM-DD',
      clearable: true
    }
  },
])
/* */

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SalaryTemplate, {
      tableFunc: _unref(fetchList),
      isTotal: true,
      searchConfig: searchConfig.value
    }, null, 8, ["tableFunc", "searchConfig"])
  ]))
}
}

})